import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FileService } from "./file.service";
import { constants } from "../constants";
import { RateCard } from "../models/rate-card.model";
import { RateCardStatus } from "../models/rate-card-status.model";

@Injectable({ providedIn: 'root' })
export class RateCardService {

    private static readonly RATE_CARD_URL = `${constants.BASE_URL}/ratecard`;

    constructor(
        private http: HttpClient,
        private fileService: FileService
    ) { }

    generateRateCard(cpaId: string, countryCode: string, cpaName: string | null, languageCode: string): Observable<RateCard> {
        return this.http.post<RateCard>(`${RateCardService.RATE_CARD_URL}/generate/${cpaId}`, { countryCode, cpaName, languageCode })
            .pipe(map((response: any) => new RateCard(response)));
    }

    isRateCardReady(id: string): Observable<RateCardStatus> {
        return this.http.get<RateCardStatus>(`${RateCardService.RATE_CARD_URL}/is-ready/${id}`)
            .pipe(map((response: any) => new RateCardStatus(response)));
    }

    downloadRateCard(id: string): Observable<File> {
        return this.http.get(`${RateCardService.RATE_CARD_URL}/download/${id}`, { observe: 'response', responseType: 'blob' })
            .pipe(map((response: HttpResponse<Blob>) => this.fileService.createFileFromHttpResponse(response)));
    }

}